import { AdminPermission } from '@graphql/types';

export const getAdminPermission = (permission: AdminPermission) => {
    return [
        permission?.dashboard && '대시보드',
        permission?.user && '회원',
        permission?.product && '상품',
        permission?.management && '운영'
    ]
        .filter(Boolean)
        .join(', ');
};
export const getPolicyType = (value: number | string) => {
    switch (value) {
        case 0:
            return '전체';
        case 1:
            return '이용약관';
        case 2:
            return '개인정보 수집 및 이용 동의';
        case 3:
            return '민감정보 수집 및 이용 동의';
        case 4:
            return '개인정보 제3자 제공 동의';
        case 5:
            return '마케팅 활용 동의';
        case 6:
            return '광고성 정보 수신 동의';
        case '전체':
            return 0;
        case '이용약관':
            return 1;
        case '개인정보 수집 및 이용 동의':
            return 2;
        case '민감정보 수집 및 이용 동의':
            return 3;
        case '개인정보 제3자 제공 동의':
            return 4;
        case '마케팅 활용 동의':
            return 5;
        case '광고성 정보 수신 동의':
            return 6;
        default:
            return value;
    }
};
export const getSystemLogType = (value: number | string) => {
    switch (value) {
        case 0:
            return '전체';
        case 1:
            return '로그인';
        case 2:
            return '데이터 CRUD';
        case 3:
            return '시스템';
        case 4:
            return '보안 및 접근 위험';
        case 5:
            return '감사 및 변경 이력';
        case '전체':
            return 0;
        case '로그인':
            return 1;
        case '데이터 CRUD':
            return 2;
        case '시스템':
            return 3;
        case '보안 및 접근 위험':
            return 4;
        case '감사 및 변경 이력':
            return 5;
        default:
            return value;
    }
};
export const getLoginType = (value: number | string) => {
    switch (value) {
        case 0:
            return '미가입';
        case 1:
            return '카카오';
        case 2:
            return '구글';
        case 3:
            return '애플';
        case 4:
            return '네이버';
        case '미가입':
            return 0;
        case '카카오':
            return 1;
        case '구글':
            return 2;
        case '애플':
            return 3;
        case '네이버':
            return 4;
        default:
            return value;
    }
};
export const getSharedStatus = (status: number) => {
    switch (status) {
        case 1:
            return '소유자';
        case 2:
            return '요청됨';
        // case 3:
        //     return '수락됨';
        default:
            return status;
    }
};
